export default __webpack_public_path__ + "locales/lo-LA/JavascriptSdk.json?hash=6724a4760ca4d74bf8dda26c877a742b";